
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'purchase-logs-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        dateFrom: '',
        dateTo: '',
        service: '',
        packageName: '',
        phone: '965',
        memberType: '',
        platform: '',
        status: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        emit('type-selected', { ...selectedItems.value });
      };

      const onReset = () => {
        selectedItems.value = {
          dateFrom: '',
          dateTo: '',
          service: '',
          packageName: '',
          phone: '965',
          memberType: '',
          platform: '',
          status: '',
        };
        emit('reset', selectedItems.value);
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_PACKAGES, { limit: 50 });
        const filter = store.getters.getPurchaseLogsFilter;

        // Set filter values from store if they exist
        if (filter?.dateFrom) {
          selectedItems.value.dateFrom = filter.dateFrom;
        }
        if (filter?.dateTo) {
          selectedItems.value.dateTo = filter.dateTo;
        }
        if (filter?.service) {
          selectedItems.value.service = filter.service;
        }
        if (filter?.packageName) {
          selectedItems.value.packageName = filter.packageName;
        }
        if (filter?.phone) {
          selectedItems.value.phone = filter.phone;
        }
        if (filter?.memberType) {
          selectedItems.value.memberType = filter.memberType;
        }
        if (filter?.platform) {
          selectedItems.value.platform = filter.platform;
        }
        if (filter?.status) {
          selectedItems.value.status = filter.status;
        }
      });

      return {
        onSubmit,
        onReset,
        translate,
        selectedItems,
        packages: computed(() => store.getters.packagesList),
      };
    },
  });
